import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../../../features/userSlice";
import { getWindowForms } from "../../Forms/api";
import WidgetFrame, { WidgetEmpty, WidgetStat } from "./WidgetFrame";

// Status buckets mirror WindowFormsSalesDashboard: what needs the
// salesperson's action vs. what's sitting with the window team.
const ACTION = ["Awaiting Sales Approval", "Needs Revision"];
const WAITING = ["Submitted", "Under Review", "Reviewing Revisions"];
const DONE = ["Approved", "Converted to Order"];

const MyWindowFormsWidget = () => {
  const user = useSelector(selectUser);
  const [forms, setForms] = useState(null);

  useEffect(() => {
    if (!user?.userID) return;
    getWindowForms(
      (data) => setForms(Array.isArray(data) ? data : []),
      user.userID
    );
  }, [user?.userID]);

  const count = (statuses) =>
    forms.filter((form) => statuses.includes(form.status)).length;

  return (
    <WidgetFrame title="My Window Forms" to="/windowdoor/sales/windowforms">
      {forms ? (
        <div className="grid grid-cols-3 gap-2">
          <WidgetStat value={count(ACTION)} label="Need my review" />
          <WidgetStat value={count(WAITING)} label="With window team" />
          <WidgetStat value={count(DONE)} label="Done" />
        </div>
      ) : (
        <WidgetEmpty>Loading window forms…</WidgetEmpty>
      )}
    </WidgetFrame>
  );
};

export default MyWindowFormsWidget;
